import { MaterialType } from "../../../types/materials";

export enum ImageCardBaseVariants {
  Default = "default",
  Dark = "dark",
}

export type ImageCardVariants = ImageCardBaseVariants | MaterialType;
